import { isTenantSmava } from 'utils/url'
import useStore from 'stores/utils/hooks/useStore'
import useVoucherAmount from './useVoucherAmount'
import { VoucherBannerVariant } from '../VoucherBanner.types'

export interface UseVoucherBannerReturn {
  isVoucherBannerVisible: boolean
  shouldShowTopActivationPromptBanner: boolean
  shouldShowTopActivatedVoucherBanner: boolean
  shouldShowContactPageVoucherActivationBanner: boolean
  isVoucherActivated: boolean
  voucherBannerVariant: VoucherBannerVariant
  voucherAmount: number | null
}

/**
 * Manages voucher banner state and side effects for both Smava and FFG tenants.
 * Determines visibility flags and fires amount-tier tracking on mount.
 *
 * Eligibility is driven purely by the resolved voucher amount per tenant.
 */
const useVoucherBanner = (): UseVoucherBannerReturn => {
  const {
    traversalSession,
    navigation: { currentPageInSession }
  } = useStore()

  const voucherAmount = useVoucherAmount()

  const isSmava = isTenantSmava()

  const isEligible = voucherAmount !== null

  const voucherBannerVariant: VoucherBannerVariant = isSmava ? 'smava' : 'ffg'

  return {
    isVoucherBannerVisible: isEligible,
    shouldShowTopActivationPromptBanner:
      isEligible && currentPageInSession === 'contact',
    shouldShowTopActivatedVoucherBanner:
      isEligible &&
      currentPageInSession !== 'contact' &&
      traversalSession.isVoucherActivated,
    shouldShowContactPageVoucherActivationBanner: isEligible,
    isVoucherActivated: traversalSession.isVoucherActivated,
    voucherBannerVariant,
    voucherAmount
  }
}

export default useVoucherBanner
